import React, { forwardRef, useImperativeHandle, useState, useEffect, cloneElement } from 'react';
import { createPortal } from 'react-dom';
import closeBtn from '../../assets/portalAssets/close.png';
import { useDispatch } from 'react-redux';
import { Dialog } from 'primereact/dialog';
import classes from './Modal.module.css';

const Modal = forwardRef(function AddUser(props, ref) {
    const dispatch = useDispatch();
    const [visible, setVisible] = useState(false);

    // Expose methods via ref
    useImperativeHandle(ref, () => ({
        open: () => setVisible(true),
        close: () => setVisible(false),
        closeOnEscape: () => setVisible(false)
    }));

    // Pass close function as a prop to children
    const childrenWithProps = React.Children.map(props.children, child =>
        cloneElement(child /*, { closemodal: () => setVisible(false) }*/)
    );

    //--------------------  Active Tab Logic-------------------------------------------------------------------------
    const { HandleShowModal, HandleCloseModal, HandleNavigateToSiteUsers, ShowHeaderTabButtons, siteId, style } = props;
    const [showHeaderTabButtons] = useState(ShowHeaderTabButtons || false);

    const tabButtons = [
        { buttonText: "Site View", HandleShowModal: HandleShowModal },
        { buttonText: "Site Users", HandleModalSwitch: () => HandleNavigateToSiteUsers(siteId) }
    ];

    const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

    //---------------------------------------------------------------------------------------------------------------------

    return createPortal(
        <Dialog
            visible={visible}
            onHide={HandleCloseModal || (() => setVisible(false))}
            className={classes.modalCard}
            closable={false} // We'll use our own custom close buttons
            dismissableMask={true} // Clicking outside will close
        >
            {/* --- Header --- */}
            <div className={isMac ? classes.MacHeader : classes.WindowsHeader}>
                <h2 className={classes.Title}>{props.title || "Main Modal Title"}</h2>
                <div className={classes.headerButtonsLayout}>
                    <ul className={classes.headerTabs}>
                        {showHeaderTabButtons &&
                            tabButtons.map((tabButton, index) => (
                                <li key={index}>
                                    <div className={`${classes.tabButton} ${tabButton.buttonText === props.modalName && classes.tabButtonActive}`} onClick={tabButton.HandleModalSwitch}>
                                        {tabButton.buttonText}
                                    </div>
                                </li>
                            ))
                        }
                    </ul>
                    <img className={`${classes.closeButton} ${isMac ? classes.MacCloseButton : ''}`} onClick={HandleCloseModal || (() => setVisible(false))} src={closeBtn} />
                </div>
            </div>

            {/* --- Body --- */}
            <div style={props.modalLayoutStyle || null} className={`${classes["modal-layout"]} ${props.className}`}>
                {childrenWithProps}
            </div>
        </Dialog>,
        document.getElementById('modal')
    );
});

export default Modal;
